import React, { useState } from "react";
import { useSelector } from "react-redux";
import PracticeAssignmentPopup from "./PracticeAssignmentPopup/PracticeAssignmentPopup";
import { Modal } from "react-responsive-modal";
import CancelPopup from "../../../../../../components/CancelPopup/CancelPopup";
import { Tooltip } from "react-tooltip";

const StudentAssignmentScore = ({
  showScore,
  getSubmissiondtls,
  onclick,
  title,
  isCurrentAssignment,
  onclick2,
  title2,
  title3,
  assignment,
  setshowScorePopup,
  setShowCongratulations,
  setcallWebSocket,
  callWebSocket,
  setwebsocketPayload,
  isNaviget,
  filteredAssignments,
  submission_Id,
  isSessionDisconnected = false,
}) => {

  const location = useSelector((state) => state?.globalState?.student_details?.data?.location)
  const getLocation = location.split(",").pop().trim();
  const Location = getLocation ? getLocation : "India";
  const isIndia = Location === "India";
  const currency_symbol = useSelector((state) => state?.globalState?.currency_symbol)
  const [hideScorePopup, setHideScorePopup] = useState(false);



  //------------------------PRACTICE ASSIGNMENT REMAINING COUNT------------------------>

  const MAX_PRACTICE = 10; // total allowed per assignment
  // null/undefined guarded — if the field is missing, treat as exhausted (safest for billing)
  const remaining = assignment?.practice_assignment_remaining_count ?? 0;
  const isFirstPracticeFree = remaining === MAX_PRACTICE;
  const noneRemaining = remaining <= 0;

  const price = isIndia ? 99 : 1;




  //------------------------------------------------------------------------------------------<
  //   const email = globalState?.email || "";

  // const isValidDomain =
  //   email.endsWith("@arcitech.ai") ||
  //   email.endsWith("@arcotgroup.com") ||
  //   email.endsWith("@webarcitech.com");

  const [showPopup, setShowPopup] = useState(false);
  const globalState = useSelector((state) => state.globalState);
  const practice_assignment_status = globalState.userCurrentPlan?.currentSubscription && globalState.userCurrentPlan.currentSubscription.plan_data.practice_assignment
  const isMarketplace = globalState.enabled_modules?.includes("marketplace");

  const practice_assignment_remaining_count = assignment?.practice_assignment_remaining_count
  const isTitle2Disabled = submission_Id === null || isSessionDisconnected;

  const isTitle3Disabled = globalState.enabled_modules?.includes("marketplace") ? (isSessionDisconnected ||
    (isNaviget
      && practice_assignment_remaining_count === 0
    )) : (
    isSessionDisconnected ||
    (isNaviget
      ? practice_assignment_remaining_count === 0
      : filteredAssignments.length === 2))


  console.warn("practice ass", practice_assignment_remaining_count, isTitle3Disabled)
  const handlePracticeAssignmentClick = () => {
    setShowPopup(true);

  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };


  return (
    <>
   <div className="AssingmentMCQs-Congratulations-popup-wrapper"   style={{ display: isMarketplace && hideScorePopup ? 'none' : undefined }}>
      <div className="AssingmentMCQs-Congratulations-popup-container">
        {!isCurrentAssignment ? (
          <i
            class="fa-solid fa-x"
            id="AssingmentMCQs-close-btn"
            onClick={showScore}
          ></i>
        ) : (
          <></>
        )}
        <span className="your-score-title">Your score</span>
        <div className="your-score-folder">
          <span className="your-score-check">
            <i class="fa-solid fa-circle-check"></i>
          </span>
          <div className="your-score">
            <span>{getSubmissiondtls?.marks_obtained ?? 0}</span>
            <span>/{getSubmissiondtls?.total_marks ?? 0}</span>
          </div>
        </div>
        <p>{getSubmissiondtls?.feedback?.replace(/(\\\()(.*?)(\\\))/g, (match, p1, p2, p3) => `$$${p1}${p2}${p3}$$`) ?? 0}</p>
        <div className="AssingmentMCQs-Congratulations-popup-btn">
          <button
            onClick={onclick}
            type="button"
            className="back-to-course"
          >
            {title}
          </button>
          {isCurrentAssignment && <> <button
            onClick={onclick2}
            type="button"
            className="View-Course"
            disabled={isTitle2Disabled}
            style={{
              cursor: isTitle2Disabled ? 'not-allowed' : 'pointer',
              backgroundColor: isTitle2Disabled ? 'grey' : '#0FBA00',
            }}
            data-tooltip-id={
              isSessionDisconnected
                ? "session-expired"
                : submission_Id === null
                  ? "submission_id_null"
                  : undefined
            }
          >
            {title2}
          </button>
            <Tooltip
              id="submission_id_null"
              place="bottom"
              content="Assignment submission failed, please contact support."
              type="light"
              effect="float"
            />

          </>}

          <div className="practice-assignment"
            // data-tooltip-id={isNaviget ? practice_assignment_remaining_count === 0 && "practice-assignment" : filteredAssignments.length === 2 && "practice-assignment"}
            // data-tooltip-id={globalState.enabled_modules?.includes("marketplace") ? (isSessionDisconnected
            //   ? "session-expired"
            //   : isNaviget
            //   && (practice_assignment_remaining_count === 0 ? "practice-assignment" : undefined)
            // ) : (
            //   isSessionDisconnected
            //     ? "session-expired"
            //     : isNaviget
            //       ? (practice_assignment_remaining_count === 0 ? "practice-assignment" : undefined)
            //       : (filteredAssignments.length === 2 ? "practice-assignment" : undefined))
            // }
            data-tooltip-id={
    isSessionDisconnected
      ? "session-expired"
      : practice_assignment_remaining_count === 0
        ? "practice-assignment"
        : undefined
  }

          >
            {/* <button
              onClick={handlePracticeAssignmentClick}
              type="button"
              className="practice-assignment-btn"
              disabled={isTitle3Disabled}
              style={{
                backgroundColor: isTitle3Disabled ? 'grey' : '', // Inline CSS to gray out the button
                cursor: isTitle3Disabled ? 'not-allowed' : 'pointer' // Disable cursor pointer when disabled
              }}
            >
              {title3}
            </button> */}

            {globalState.enabled_modules?.includes("marketplace") ?
              <button
                onClick={handlePracticeAssignmentClick}
                type="button"
                className="practice-assignment-btn"
                disabled={isTitle3Disabled || noneRemaining}
                style={{
                  backgroundColor: isTitle3Disabled || noneRemaining ? 'grey' : '', // Inline CSS to gray out the button
                  cursor: isTitle3Disabled || noneRemaining ? 'not-allowed' : 'pointer' // Disable cursor pointer when disabled
                }}
              >
                {isFirstPracticeFree ? `${title3}: Free` : `${title3}: ${currency_symbol}${price}`}
              </button> : <button
                onClick={handlePracticeAssignmentClick}
                type="button"
                className="practice-assignment-btn"
                disabled={isTitle3Disabled}
                style={{
                  backgroundColor: isTitle3Disabled ? 'grey' : '', // Inline CSS to gray out the button
                  cursor: isTitle3Disabled ? 'not-allowed' : 'pointer' // Disable cursor pointer when disabled
                }}
              >
                {title3}
              </button>
            }
          </div>
          {practice_assignment_remaining_count === 0 && <Tooltip
            id="practice-assignment"
            place="bottom"
            // content="No more than 2 review assignments can be generated."
            content={
              globalState.enabled_modules?.includes("marketplace")
                ? "No more than 10 practice assignments can be generated."
                : "No more than 2 practice assignments can be generated."
            } type="light"
            effect="float"
          />}
        </div>
        <Tooltip
          id="practice-assignment"
          place="bottom"
          // content="No more than 2 review assignments can be generated."
          content={
            globalState.enabled_modules?.includes("marketplace")
              ? "No more than 10 practice assignments can be generated."
              : "No more than 2 practice assignments can be generated."
          } type="light"
          effect="float"
        />

        <Tooltip
          id="session-expired"
          place="bottom"
          content="Session expired, please try again."
          type="light"
          effect="float"
        />

      </div>
      {showPopup && <PracticeAssignmentPopup assignment={assignment} onClose={handleClosePopup} setShowPopup={setShowPopup} setshowScorePopup={setshowScorePopup}
        setShowCongratulations={setShowCongratulations} setcallWebSocket={setcallWebSocket} callWebSocket={callWebSocket} setwebsocketPayload={setwebsocketPayload} isNaviget={isNaviget} setHideScorePopup={isMarketplace ? setHideScorePopup : undefined}/>}
    </div>
    </>
  );
};

export default StudentAssignmentScore;